import { generateInteractionProps } from "@/utils/generate-smart-toilets-interactions"
import { pushAnalyticsObjToDataLayer } from "@/utils/helper"

export const handleLearnMoreClick = type => {
  const interactionData = generateInteractionProps(type, {
    internalLinkName: type,
    internalLinkPosition: "pxp:product navigation",
    internalLinkType: `pxp:${type}`,
    internalLinkZoneName: "pxp:shop smart toilets:compare models",
  })

  pushAnalyticsObjToDataLayer({ ...interactionData })
}
